"use client";

import { useState } from "react";
import BookletAboutUs from "@/components/booklets/BookletAboutUs";
import BookletFilterCard from "@/components/booklets/BookletFilterCard";
import BookletsListCard from "@/components/booklets/BookletsListCard";
import { Pagination } from "@/components/common/index";
import Header from "@/components/ui/Header/Header";
import Search from "@/components/ui/Search";
import BookletDetailsCard from "@/components/booklets/BookletDetailsCard";
import { BookletCategory, BookletDate, BookletDetails, BookletList } from "@/@types";

export default function BookletContainer({
  BookletList,
  BookletCategory,
  BookletDate,
  BookletDetail, 
}: {
  BookletList?: BookletList;
  BookletCategory: BookletCategory[];
  BookletDate: BookletDate;
  BookletDetail?: BookletDetails;
}) {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const toggleFilterModal = () => {
    setIsFilterModalOpen((prev) => !prev);
  };


  return (
    <div className="bg-silver">
      <Header
        variant="dark"
        description="En Matco, buscamos que tu elección sea segura y adecuada a tus necesidades. Aquí encontrarás información sobre nuestros servicios, cultura, maquinaria, refacciones, tecnología, garantías, y beneficios de rentar equipos ligeros, además de detalles específicos de las máquinas que te interesan."
      />
      <div className="container pb-32 bg-silver">
        <div className="grid lg:grid-cols-[25%_90%] mt-8">
          <div className="grid grid-cols-1 auto-rows-min gap-4">
            <Search onOpenFilters={toggleFilterModal} />
            <BookletFilterCard 
              isMenuOpen={isFilterModalOpen}
              toggleMenu={toggleFilterModal}
              categories={BookletCategory} 
              bookletsDate={BookletDate} 
            />
            {/* Se muestra en desktop */}
            <div className="hidden lg:block">
              <BookletAboutUs />
            </div>
          </div>
          <div className="w-full lg:w-[85%] lg:pl-4 lg:pt-0">
            {BookletDetail ? (
              <BookletDetailsCard bookletDetails={BookletDetail} />
            ) : (
              <>
                <BookletsListCard bookletsList={BookletList} />
                <Pagination
                  result="Folletos"
                  currentPage={BookletList?.meta.currentPage}
                  lastPage={BookletList?.meta.lastPage}
                  totalResults={BookletList?.meta.total}
                  perPage={BookletList?.meta.perPage}
                />
              </>
            )}
          </div>
        </div>
        <div className="block lg:hidden mt-8">
          <BookletAboutUs />
        </div>
      </div>
    </div>
  );
}
